import React from "react";
import { observer } from "mobx-react";
import EntityList from "../../../../EntityManager/components/EntityList";
import { Operation } from "../../../../EntityManager";
import { useStore } from "../../../../../store/rootStore";
import styles from "./ManagerListView.module.scss";
function ManagerListView({ entities, entityIdKey, teaser, teaserProps, loading = false, disabled, readOnly, sorter, customListActions, customActionIcons, renderListItem, opSupported, onEntitySelect, onEntityDelete, createTitle, }) {
    const { ui } = useStore();
    const selectedId = ui.getManagerItemId();
    const handleEdit = (entity) => {
        onEntitySelect(entity);
    };
    const handleDelete = (entity) => {
        if (onEntityDelete) {
            onEntityDelete(entity);
        }
    };
    const canEdit = !opSupported || opSupported.includes(Operation.EDIT);
    const canDelete = !opSupported || opSupported.includes(Operation.DELETE);
    const canClick = canEdit || canDelete;
    return (React.createElement("div", { className: styles.listViewContainer },
        React.createElement(EntityList, { entities: entities, loading: loading, teaser: teaser, additionalProps: teaserProps, entityIdKey: entityIdKey, disabled: disabled, readOnly: readOnly, createTitle: createTitle, onEdit: canClick ? handleEdit : undefined, onDelete: canDelete ? handleDelete : undefined, sorter: sorter, customListActions: customListActions, customActionIcons: customActionIcons, renderListItem: renderListItem, currentOperation: Operation.LIST, selectedEntityId: selectedId })));
}
export default observer(ManagerListView);
